module.exports = __webpack_public_path__ + "img/icon-credit-card@3x.f40cc5fb.png";